/** @format */

import { HomrGTGTContent, HomrScheduleContent } from '@shared/data-access/interfaces';
import { createReducer, on } from '@ngrx/store';
import { setHomrGTGTContent, setHomrScheduleContent } from './homr.actions';

interface HomrState {
	homrGTGTContent: HomrGTGTContent;
	homrScheduleContent: HomrScheduleContent;
}

export const initHomrState: HomrState = {
	homrScheduleContent: null,
	homrGTGTContent: null
};

export const homrReducers = createReducer(
	initHomrState,
	on(setHomrScheduleContent, (state, { homrScheduleContent }) => ({
		...state,
		homrScheduleContent
	})),
	on(setHomrGTGTContent, (state, { homrGTGTContent }) => ({
		...state,
		homrGTGTContent
	}))
);

// export for module import
export function homrReducer(state, action) {
	return homrReducers(state, action);
}
